import { lazy } from 'react'
import MainLayout from '@/layouts/MainLayout'
import type { LazyRouteFunction } from 'react-router-dom'

// 懒加载组件
const Home = lazy(() => import('@/views/Home'))
const LearnCenter = lazy(() => import('@/views/LearnCenter'))
const UserManagement = lazy(() => import('@/views/UserManagement'))
const NewBiography = lazy(() => import('@/views/Home/NewBiography'))
const Biography = lazy(() => import('@/views/Biography'))
const Writing = lazy(() => import('@/views/Writing'))
const BiographyEdit = lazy(() => import('@/views/Biography/Edit'))
const Preview = lazy(() => import('@/views/Preview'))

export interface RouteObject {
  path?: string
  label?: string
  key?: string
  icon?: string
  element?: React.ReactNode
  hidden?: boolean
  sort?: number
  children?: RouteObject[],
  lazy?: LazyRouteFunction<RouteObject>;
}

// 对路由进行排序
const routers: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      {
        path: '/home',
        label: '写作台',
        sort: 1,
        key: 'home',
        icon: 'outline-home',
        element: <Home />,
      },
      {
        path: '/learn-center',
        label: '学习中心',
        sort: 2,
        key: 'learn-center',
        icon: 'outline-education',
        element: <LearnCenter />,
      },
      {
        path: '/user-management',
        label: '用户管理',
        sort: 3,
        key: 'user-management',
        icon: 'outline-user-feather',
        element: <UserManagement />,
      },
      {
        path: '/home/new-biography',
        label: '新建传记',
        sort: 5,
        key: 'new-biography',
        hidden: true,
        element: <NewBiography />,
      },
    ],
  },
  // Biography 详情页 - 使用独立布局，包含嵌套路由
  {
    path: '/biography/:id',
    label: '传记详情',
    sort: 4,
    key: 'biography-detail',
    hidden: true,
    element: <Biography />,
    children: [
      {
        path: 'drafts',
        label: '传记草稿',
        key: 'biography-drafts',
        hidden: true,
        lazy: async () => {
          const { default: Drafts } = await import('@/views/Biography/Drafts')
          return { element: <Drafts /> }
        },
      },
      {
        path: 'drafts/:draftId/chapters',
        label: '草稿目录',
        key: 'biography-draft-content',
        hidden: true,
        lazy: async () => {
          const { default: Chapters } = await import('@/views/Biography/Chapters')
          return { element: <Chapters /> }
        },
      },
      {
        path: 'info',
        label: '传记信息',
        key: 'biography-info',
        hidden: true,
        lazy: async () => {
          const { default: Info } = await import('@/views/Biography/Info')
          return { element: <Info /> }
        },
      },
      {
        path: 'documents',
        label: '文档资料',
        key: 'biography-documents',
        hidden: true,
        lazy: async () => {
          const { default: Documents } = await import('@/views/Biography/Documents')
          return { element: <Documents /> }
        },
      },
      {
        path: 'recordings',
        label: '采访录音',
        key: 'biography-recordings',
        hidden: true,
        lazy: async () => {
          const { default: Recordings } = await import('@/views/Biography/Recordings')
          return { element: <Recordings /> }
        },
      },
    ],
  },
  // Writing 页面 - 使用独立布局
  {
    path: '/writing',
    label: '写作',
    sort: 6,
    key: 'writing',
    hidden: true,
    element: <Writing />,
  },
  // 传记编辑页面 - 全屏独立布局
  {
    path: '/biography/:id/drafts/:draftId/chapters/:chapterId/edit',
    label: '传记编辑',
    sort: 7,
    key: 'biography-edit',
    hidden: true,
    element: <BiographyEdit />,
  },
  // 草稿预览页面 - 全屏独立布局
  {
    path: '/biography/:id/drafts/:draftId',
    label: '草稿预览',
    sort: 8,
    key: 'draft-preview',
    hidden: true,
    element: <Preview />,
  },
]

export default routers
